<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11sd4P1/tc-custom/9781421400303.jpg?1705766049310" alt="This image is the cover for the book Faces of the Confederacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Faces of the Confederacy
      </h1>
      <p class="bookDescription body article font2">
        <b>“Extensive research, fascinating characters . . . The author has done an admirable job of literally placing a face on the ordinary Confederate soldier.” —<i>The Journal of Southern History</i></b><br/><br/>“The history of the Civil War is the stories of its soldiers,” writes Ronald S. Coddington in the preface to <i>Faces of the Confederacy</i>. This book tells the stories of seventy-seven Southern soldiers—young farm boys, wealthy plantation owners, intellectual elites, uneducated poor—who posed for photographic portraits, <i>cartes de visite</i>, to leave with family, friends, and sweethearts before going off to war. Coddington, a passionate collector of Civil War-era photography, conducted a monumental search for these previously unpublished portrait cards, then unearthed the personal stories of their subjects, putting a human face on a war rife with inhuman atrocities.<br/><br/>The Civil War took the lives of twenty-two of every hundred men who served. Coddington follows the exhausted survivors as they return home to occupied cities and towns, ravaged farmlands, a destabilized economy, and a social order in the midst of upheaval. This book is a haunting and moving tribute to those brave men.<br/><br/>Like its companion volume, <i>Faces of the Civil War: An Album of Union Soldiers and Their Stories</i>, this book offers readers a unique perspective on the war and contributes to a better understanding of the role of the common soldier.<br/><br/><b>“With his meticulous research and a journalist’s eye for good stories, Ron Coddington has brought new life to Civil War photographic portraits of obscure and long-forgotten Confederates whose wartime experiences might otherwise have been lost to history.” —Bob Zeller, cofounder and president of the nonprofit Center for Civil War Photography</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ronald S. Coddington, Michael Fellman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Johns Hopkins University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03e0e0e8